import React from "react";

import { TwMainLayout, TwStoreButton } from "../../../components/tailwind";
import { useTenant } from "../../../provider/TenantProvider";
import { defaultDomainList } from "../../../utils/constants";
import AuthShell, { AuthHeading } from "../../../components/auth/AuthShell";

/**
 * /get-app — the one link for the FitClub app (welcome email "Download the app", QR code after activation).
 * On an iPhone/iPad it goes to the App Store, on Android to Google Play; anywhere else it shows both buttons.
 */

export const APP_STORE_URL = "https://apps.apple.com/nl/app/fitclub-by-bookzyme/id1560700866?l=en-GB";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.bookzy.fitclub";

export const storeForThisDevice = () => {
  const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
  const iPadOS = typeof navigator !== "undefined" && navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  if (/iPhone|iPad|iPod/i.test(ua) || iPadOS) return APP_STORE_URL;
  if (/Android/i.test(ua)) return PLAY_STORE_URL;
  return "";
};

export function StoreButtons() {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <TwStoreButton btnType="apple" url={APP_STORE_URL} />
      <TwStoreButton btnType="google" url={PLAY_STORE_URL} />
    </div>
  );
}

export default function GetAppPage() {
  const { tenant, tenantData } = useTenant();
  const club = defaultDomainList.indexOf(tenant) < 0 && tenantData?.business_details ? tenantData.business_details : null;
  const store = React.useMemo(storeForThisDevice, []);

  React.useEffect(() => {
    if (store) window.location.replace(store);
  }, [store]);

  return (
    <TwMainLayout fullScreen={true} checkSession={false} userType="skip">
      <AuthShell club={club} brandTitle="Get the FitClub app." brandLine="Book classes and see your credits on the go.">
        <div className="flex flex-col gap-6">
          <AuthHeading eyebrow="FITCLUB APP" title="Get the FitClub app">
            {store ? "Taking you to the app store…" : "Download FitClub for your phone, then sign in with your mobile number and password."}
          </AuthHeading>
          <StoreButtons />
        </div>
      </AuthShell>
    </TwMainLayout>
  );
}
